export default "__VITE_ASSET__e0c5cb04__"